import React, { useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { AddActivityIcon } from './BuilderComponents';

export default function ActivitiesSection({ onActivityListChange, activityList, timesList, onTimesListChange }) {
  const [activity, setActivity] = useState('');
  const [maxGroups, setMaxGroups] = useState('');
  const activityRef = useRef();
  const [shouldFocus, setShouldFocus] = useState(false);
  

  const handleAddActivity = () => {
    let newActivity = [];
  
    if (activity) {
      // Find the highest activity number among non-deleted activities
      const highestActivityNumber = activityList.reduce((max, activity) => {
        if (!activity.isDeleted && activity.activityNumber > max) {
          return activity.activityNumber;
        }
        return max;
      }, 0);
  
      const currentActivityNumber = highestActivityNumber + 1;
  
      if (maxGroups !== '') {
        newActivity = { activity, activityNumber: currentActivityNumber, maxGroups };
      } else {
        newActivity = { activity, activityNumber: '', maxGroups };
      }
      onActivityListChange([...activityList, newActivity]);
      onTimesListChange([...timesList, '']); // Add an empty string to timesList
      setActivity('');
      setMaxGroups('');
    }
  };
  const handleDeleteActivity = (index) => {
    const updatedActivityList = activityList.map((activity, i) => {
      if (i === index) {
        return { ...activity, isDeleted: true };
      }
      return activity;
    }).filter(activity => !activity.isDeleted);
  
    // Renumber the remaining activities
    const renumberedActivityList = updatedActivityList.map((activity, index) => ({
      ...activity,
      activityNumber: index + 1 // Renumber the activities starting from 1
    }));
  
    // Update the state with the renumbered activity list
    onActivityListChange(renumberedActivityList);
  };
  
  
  useEffect(() => {
    if (shouldFocus) {
      activityRef.current.focus();
      setShouldFocus(false);
    }
  }, [shouldFocus]);

  return (
    <tr className='text-center' style={{ borderBottom: '1px solid #ccc', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#F3F3F3' }}>
        <td style={{ border: 'none', padding: 0 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', paddingTop: '0.5rem', backgroundColor: '#F3F3F3'}}>
            <TextField
              id="filled-basic"
              label="Activity"
              variant="filled"
              value={activity}
              onChange={(e) => setActivity(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleAddActivity();
                  setShouldFocus(true);
                }
              }}
              style={{ marginLeft: '1%', marginRight: '1%', width: '50%' }}
              inputRef={activityRef}
            />
            <TextField
              id="filled-basic-max"
              label="Maximum # of groups at once"
              variant="filled"
              type="number"
              min="1"
              helperText="Leave blank for large group activities (eg. arrival or lunch)"
              value={maxGroups}
              onChange={(e) => {
                const newValue = e.target.value === '0' ? '' : e.target.value;
                setMaxGroups(newValue);
              }}
                onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleAddActivity();
                  setShouldFocus(true);
                }
              }}
              style={{ marginLeft: '1%', marginRight: '1%', width: '50%' }}
            />
            <AddActivityIcon style={{ marginTop: '1rem'}} onClick={handleAddActivity} />
          </div>
          {activityList.length > 0 && (
            <div style={{ paddingTop: '1rem', backgroundColor: '#F3F3F3' }}>
              {activityList.map((activity, index) => (
                // Only render the activity if it's not deleted
                !activity.isDeleted && (
                  <div className='position-relative d-inline-block' key={index}>
                    <Button style={{ cursor: 'default', marginLeft: '1rem', marginBottom: '1rem', color: 'white', backgroundColor: 'var(--main-color)'}}>
                      {activity.activity}
                      {activity.maxGroups !== '' && (
                        <>
                          ({activity.maxGroups}){' '}
                        </>
                      )}
                      <span style={{ color: 'white', cursor: 'pointer' }} onClick={() => handleDeleteActivity(index)}>&nbsp;&nbsp;&times;</span>
                    </Button>
                  </div>
                )
              ))}
            </div>
          )}
        </td>
    </tr>
  );
}